// eslint-disable-next-line import/extensions
import { getCountryCallingCode } from 'libphonenumber-js';

const percent = dec => `${(dec * 100).toFixed(0)}%`;
const date = d => (d ? `${d.toLocaleDateString()} ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}` : '');
const dateOnly = d => (d ? d.toLocaleDateString() : '');
const dateToFormattedString = (dateValue) => {
  if (!dateValue || !(dateValue instanceof Date)) {
    return '';
  }
  const offset = dateValue.getTimezoneOffset();
  const offsetDate = new Date(dateValue.getTime() + (offset * 60 * 1000));
  return offsetDate.toISOString().split('T')[0];
};

const countryCallingCode = countryCode => getCountryCallingCode(countryCode);

const datastr = (val) => {
  let bytes = parseInt(val, 10);
  if (bytes) {
    const thresh = 1000;
    const units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    if (Math.abs(bytes) < thresh) {
      return `${bytes} B`;
    }

    let u = -1;
    do {
      bytes /= thresh;
      // eslint-disable-next-line no-plusplus
      ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return `${bytes.toFixed(1)} ${units[u]}`;
  }
  return '';
};

export default {
  install(Vue) {
    Vue.filter('date', date);
    Vue.filter('dateOnly', dateOnly);
    Vue.filter('percent', percent);
    Vue.filter('datastr', datastr);
    Vue.filter('dateFormat', dateToFormattedString);
    Vue.filter('countryCallingCode', countryCallingCode);
  },
};
